import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { Input } from 'components';

import { LocationSVG, CalendarSVG, UserSVG } from 'lib/icons';
import AlertSVG from 'assets/icons/Alert.svg';
import { AutoCompleteWrapper, SearchBar } from './SearchBarPanel.styles';

const SearchBarPanelMobile = ({ onSearchFocus }) => {
  const intl = useIntl();

  return (
    <SearchBar
      width="100%"
      displayLaptop="block"
      style={{ position: 'relative' }}
    >
      <AutoCompleteWrapper
        width="368px"
        widthLaptop="100%"
        height="54px"
        marginLaptop="48px 0 77px 0"
      >
        <LocationSVG />
        <Input
          bgInput="transparent"
          width="90%"
          type="text"
          placeholder={intl.formatMessage({
            id: 'filters.city',
          })}
          placeholderColor="white"
          onFocus={() => onSearchFocus(true)}
        />
      </AutoCompleteWrapper>
    </SearchBar>
  );
};

export { SearchBarPanelMobile };
